module.exports = __webpack_public_path__ + "static/media/artista.947fe4c4.png";